import ajax from './ajax'
let dataUrl = process.env.VUE_APP_BASEURL;

export const abort = () => {
  return ajax.abort()
}


export const init = () => {
  const result = {
    lang: 'en'
  }
  const path = dataUrl + 'thirdpartytournament/getConfig'
  return ajax.post(path, result)
}

export const getConfig = (id) => {
  const result = {
    lang:localStorage.getItem('LOCAL_LANG') || "en",
    id
  }
  const path = dataUrl + 'thirdpartytournament/getContryConfig'
  return ajax.post(path, result)
}

export const sendVc = (type, email, lang = 'en') => {
  const result = {
    type,
    email,
    lang:localStorage.getItem('LOCAL_LANG') || "en",
  }
  const path = dataUrl + 'thirdpartytournament/sendCaptcha'
  return ajax.post(path, result)
}

export const submitForm = (email, captcha, info, country_id, tag, apply_time_cus, lang = 'en') => {
  const result = {
    email,
    captcha,
    info,
    country_id,
    tag,
    apply_time_cus,
    lang: localStorage.getItem('LOCAL_LANG') || "en",
  }
  const path = dataUrl + 'thirdpartytournament/apply'
  return ajax.post(path, result)
}

export const getHistory = (captcha, email, lang = 'en') => {
  const result = {
    captcha,
    email,
    lang:localStorage.getItem('LOCAL_LANG') || "en",
  }
  const path = dataUrl + 'thirdpartytournament/searchList'
  return ajax.post(path, result)
}
